import React from 'react';

import { AuthProviderContext } from './AuthProvider.context';

import type { AuthContextProperties } from './AuthProvider.types';

export const useAuth = (): AuthContextProperties => {
  return React.useContext(AuthProviderContext);
};
